import React from 'react';

const clickableIcon = (props) => {
    
    let iconStyle = {};
    if(typeof props.iconPath!=='undefined'){
        iconStyle = {
            'backgroundImage': 'url('+props.iconPath+')',
        }
    }

    return(
        <span
            id={props.name}
            style={iconStyle} 
            className={["clickable-icon", props.class].join(' ')}
            onClick={props.action}>{props.children}</span>
    )
};

export default clickableIcon;


// WEBPACK FOOTER //
// ./src/containers/UI/ClickableIcon/ClickableIcon.js